/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { TInputEvent, InputInterceptor } from "../types/TInputEvent";
import type { InputMode } from "../types/TInputMode";

/**
 * Tracks whether the user is currently in keyboard or pointer mode.
 *
 * Critical for LG WebOS Magic Remote which can switch between air-mouse
 * and D-pad freely. Applications typically show/hide the cursor and
 * adjust focus styling based on the current mode.
 */
export function createInputModeInterceptor(
  onModeChange: (mode: InputMode) => void
): InputInterceptor {
  let currentMode: InputMode = "key";

  return (event: TInputEvent): void => {
    const newMode: InputMode = event.source === "pointer" ? "pointer" : "key";

    if (newMode !== currentMode) {
      currentMode = newMode;
      onModeChange(currentMode);
    }
  };
}
